import React, { useState, memo } from 'react';
import TooltipPortal from '../tooltip/TooltipPortal';

import styles from './styles/PillMenu.module.css';

const PillMenu = ({ tabs, activeTab, onTabChange }) => {
    const [hoveredIndicator, setHoveredIndicator] = useState(null);

    if (tabs.length < 2) return null;

    return (
        <div className={styles.pillMenu}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`${styles.pill} ${activeTab === tab.id ? styles.active : ''}`}
                    onClick={() => onTabChange(tab.id)}
                >
                    {tab.icon && <span className={styles.icon}>{tab.icon}</span>}
                    <span className={styles.label}>{tab.label}</span>
                    {tab.indicator?.show && (
                        <TooltipPortal
                            tooltip={tab.indicator?.tooltip}
                            show={hoveredIndicator === tab.id}
                        >
                            <span
                                className={styles.indicatorWrapper}
                                onMouseDown={e => e.stopPropagation()}
                                onClick={e => e.stopPropagation()}
                                onMouseEnter={() => setHoveredIndicator(tab.id)}
                                onMouseLeave={() => setHoveredIndicator(null)}
                            >
                                <span className={styles.indicatorDot} />
                            </span>
                        </TooltipPortal>
                    )}
                </button>
            ))}
        </div>
    );
};

export default memo(PillMenu);
